import { clsx } from 'clsx';
import { useTheme } from './ThemeProvider.js';
import classes from './BaseStyles.module.css.js';
import 'focus-visible';
import { BoxWithFallback } from './internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

function BaseStyles({
  children,
  color,
  fontFamily,
  lineHeight,
  className,
  as: Component = 'div',
  style,
  ...rest
}) {
  const {
    colorMode,
    colorScheme,
    dayScheme,
    nightScheme
  } = useTheme();
  const newClassName = clsx(classes.BaseStyles, className);
  const baseStyles = {
    ['--BaseStyles-fgColor']: color,
    ['--BaseStyles-fontFamily']: fontFamily,
    ['--BaseStyles-lineHeight']: lineHeight
  };
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: Component,
    className: newClassName,
    "data-portal-root": true
    /**
     * We need to map valid primer/react color modes onto valid color modes for primer/primitives
     * valid color modes for primer/primitives: auto | light | dark
     * valid color modes for primer/primer: auto | day | night | light | dark
     */,
    "data-color-mode": colorMode === 'auto' ? 'auto' : colorScheme !== null && colorScheme !== undefined && colorScheme.includes('dark') ? 'dark' : 'light',
    "data-light-theme": dayScheme,
    "data-dark-theme": nightScheme,
    style: {
      ...baseStyles,
      ...style
    },
    ...rest,
    children: children
  });
}
BaseStyles.displayName = "BaseStyles";

export { BaseStyles as default };
